import React, { RefObject, useContext } from 'react';

export enum PageType {
  LIST = 'list',
  DETAIL = 'detail'
}

export type TableContext = {
  contentNodeForButtons: RefObject<HTMLDivElement | null>;
  context: {
    page: string;
    type: PageType;
    setPageType: React.Dispatch<PageType>;
  };
};

export const tableContext = React.createContext<TableContext>({
  contentNodeForButtons: { current: null },
  context: {
    page: '',
    type: PageType.LIST,
    setPageType: () => null
  }
});

const useTableContext = () => useContext<TableContext>(tableContext);

export default useTableContext;
